import api from "@/request/api"
import { Get,Post } from "@/request/index"
import { checkIdcard } from "@/utils/index"

// 校验电话是否注册
export let validatePhone = async (rule, value, callback) => {
  const res = await checkRepeat("phone", value)
  if (res) {
    callback(new Error("当前电话号码已注册"));
    return
  }
  callback()
}

// 校验用户名
export let validateUsername = async(rule, value, callback) => {
  var pattern1 = /[^a-zA-Z0-9_]/g;
  if (pattern1.test(value)) {
    callback(new Error("只支持输入英文和数字"));
  } else {
    const res = await checkRepeat("username",value)
    if(res){
      callback(new Error("当前账号已经注册过了"));
      return
    }
    callback();
  }
};



// 校验邮箱
export let  validateEmail = async (rule, value, callback) => {
  var pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
  if (!pattern.test(value)) {
    return callback(new Error("邮箱格式错误"));
  }
  const res = await checkRepeat("email",value)
  if(res){
    return callback(new Error("当前邮箱已注册"));
  }
  callback();
};

//校验身份证
export let validateIdentity = (rule, value, callback)=>{
  if(value==''){
    return callback(new Error("请输入身份证号"));
  }
  if(!checkIdcard(value)){
    return callback(new Error("身份证号输入错误"));
  }
  callback();
}


//校验身份证
export let checkIdentityValue = (rule, value, callback)=>{
  if (!value) {
    return callback();
  }
  if(!checkIdcard(value)){
    return callback(new Error("身份证号输入错误"));
  }
  callback();
}


// 校验手机
export let checkMobile = (rules,value,callback) => {
  if(value==''){
    return callback(new Error("手机号码不能为空"));
  }
  var pattern = /^1[3456789]\d{9}$/;
  if(!pattern.test(value)){
    return callback(new Error("手机号码错误"))
  }
  callback()
}

// 校验手机value
export let checkMobileValue = (rules,value,callback) => {
  if (!value) {
    return callback();
  }
  var pattern = /^1[3456789]\d{9}$/;
  if(!pattern.test(value)){
    return callback(new Error("手机号码错误"))
  }
  callback()
}



// 校验整数
export let checkInt = (rules,value,callback) => {
  if(!Number.isInteger(value)){
    return callback(new Error("请输入整数"));
  }
  callback()
}



// 校验整数值
export let checkIntValue = (rules,value,callback) => {
  if (!value) {
    return callback();
  }
  if(!isNumber(value)){
    return callback(new Error("请输入数字"));
  }
  callback()
}

// 判断是否是数字
export function isNumber(input) {
    return !isNaN(input) && input.trim() !== '' && /^[0-9]+(\.[0-9]+)?$/.test(input);
}

//校验小数
export let checkDecimal = (rules,value,callback) => {
  if(Number.isInteger(value)){
    return callback(new Error("请输入小数"));
  }
  callback()
}

//检验只能输入电话长度
export const checkPhoneLength = (rule, value, callback)=>{
  if( value === ""){
    return callback(new Error("电话号码不能为空"))
  }else if(value.length!==11){
    return callback(new Error(`电话号码为11位,当前为${value.length}位,当前${value.length}位`))
  }else{
    var pattern = /^[0-9]+$/; 
    if(!pattern.test(Number(value))){
      return callback(new Error("只能输入数字"))
    }
    callback()
  }
}

//校验版权声明
export let checkStatement = (rules,value,callback)=>{
  if(!value){
    return callback(new Error("请勾选版权声明"))
  }
  callback()
}

//校验邮箱
export let checkEmail = (rules,value,callback) => {
  var pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
  if (!pattern.test(value)) {
    return callback(new Error("邮箱格式错误"));
  }
  callback()
}

//校验邮箱
export let checkEmailValue = (rules,value,callback) => {
  if (!value) {
    return callback();
  }
  var pattern = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
  if (!pattern.test(value)) {
    return callback(new Error("邮箱格式错误"));
  }
  callback()
}
//检查是否重复
export let checkRepeat = async (mode, value) => {
  let params = {}
  params[mode] = value
  const flag = await Post(api.com.checkRepeat, params)
  return flag
}

//检查最大和最小
export var checkSelectNum = (rule, value, callback)=>{
  if(value.length<rule.minNum){
    return callback(new Error(`最少勾选${rule.minNum}个`));
  }
  if(value.length>rule.maxNum){
    return callback(new Error(`最多勾选${rule.maxNum}个`));
  }
  callback()
}